import React, { Fragment } from 'react'
import { Breadcrumb } from 'antd'
import { Link, } from 'react-router-dom'
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import Header4 from 'src/components/Header/Header4'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'
import { MenuCard } from '../component/index'
import { TechnicalServiceCardList } from '../component/Datas/normalDatas'
import './style.css'
export default function TechnicalService(props) {
    const { data } = props;
    return (
        <div className='TechnicalService' >
            <div className='TechnicalServiceMain' id='TechnicalServiceMain'>
                <div className='TechnicalServiceTitle'>
                    <Header4 />
                </div>
                <div className='TechnicalServiceMainScroll' >
                    <div className='TechnicalServiceContent'>
                        <div className='TechnicalServiceContentMain'>
                            <div className='TechnicalServiceContentLeft'>
                                <Breadcrumb>
                                    <Breadcrumb.Item >
                                        <Link to='/Guide'>首页</Link>
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item >技术服务</Breadcrumb.Item>
                                </Breadcrumb>
                                <div className='TechnicalServiceContent_Title'>技术服务</div>
                                <div className='TechnicalServiceContent_Introduce'>为用户提供基础遥感数据查询、处理的平台</div>
                                <div className='TechnicalServiceContent_CardList'>
                                    {TechnicalServiceCardList.map((card, index) => {
                                        return (
                                            <div className='TechnicalServiceContent_Card'>
                                                <MenuCard data={card} key={index} />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <MainBottom data={unitsList} />
                </div>
            </div>
        </div>
    )
}